import { createTheme } from "@mui/material/styles";

// Theme builder the KYC application
const theme = createTheme({
  palette: {
    primary: {
      main: "#007CBF",
    },
    secondary: {
      main: "#012848",
    },
    error: {
      main: "#C51500",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: { marginLeft: 0 },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: "#f0f0f0",
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        sizeLarge: {
          height: "48px",
        },
        root: {
          textTransform: "none",
        },
      },
    },
  },
  typography: {
    fontFamily: "Noto Sans, Arial, sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 500,
      letterSpacing: 0,
    },
    h2: {
      fontSize: "1.125rem",
      fontWeight: 700,
    },
    h3: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "22px",
    },
    h4: {
      fontSize: "1.25rem",
      fontWeight: 500,
      letterSpacing: "0.25px",
    },
    h5: {
      fontSize: "1rem",
      fontWeight: 500,
      letterSpacing: 0,
    },
    h6: {
      fontSize: "1.125rem",
      fontWeight: 700,
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      letterSpacing: "0.4px",
    },
    overline: {
      fontSize: "0.75rem",
      fontWeight: 400,
      letterSpacing: "1.5px",
    },
    subtitle1: {
      fontSize: "0.875rem",
      fontWeight: 700,
      lineHeight: "17px",
    },
    subtitle2: {
      fontSize: "0.75rem",
      fontWeight: 600,
      letterSpacing: "0.1px",
    },
    body1: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "19px",
    },
    body2: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: "16px",
    },
  },
});

export default theme;
